import { FC } from 'react'
import { Form } from 'react-bootstrap'
import { FieldProps } from '../Forms.d'

const CheckboxField: FC<FieldProps> = ({
    id,
    label = '',
    name,
    formikProps,
    groupClassName = '',
    className = '',
    required = false,
    disabled = false,
    readonly = false,
    value,
    onBlur,
}) => {
    const { values, errors, touched, handleChange } = formikProps

    return (
        <Form.Group
            className={
                (groupClassName || '') +
                ' sfy-field mb-3' +
                (required ? ' required' : '')
            }
            controlId={id}
        >
            <Form.Check type={'checkbox'} id={id}>
                <Form.Check.Input
                    type={'checkbox'}
                    name={name}
                    value={value}
                    checked={values[name].includes(value)}
                    onChange={handleChange}
                    isValid={!(errors[name] && touched[name])}
                    className={
                        (className || '') +
                        ` ${
                            errors[name] && touched[name]
                                ? 'is-invalid'
                                : 'is-valid'
                        } ${readonly ? ' readonly' : ''}`
                    }
                    onBlur={(e) => {
                        if (onBlur) onBlur(e)
                    }}
                    disabled={disabled}
                    readOnly={readonly}
                    autoComplete={name + '-' + new Date().getMilliseconds()}
                />
                <Form.Check.Label>{label}</Form.Check.Label>

                {/* {errors[name] && touched[name] && (
                <Form.Text className="invalid-feedback">
                    {errors[name].toString()}
                </Form.Text>
                <Form.Control.Feedback type="valid">
                    You did it!
                </Form.Control.Feedback>
            )} */}
            </Form.Check>
            <span className="bottom-border"></span>
        </Form.Group>
    )
}

export default CheckboxField
